import {ModelViewer} from './lib/ModelViewer';
import {BasicStudioSceneGLTF, SceneParams} from './scene/BasicStudioSceneGLTF';
import {Intro} from './scene/Intro';

export function runApp(loadAssets, loadModels, introLoad, lotterySlug: string, introImage: string, debug: boolean = false) {
    window.addEventListener(
        'beforeunload',
        function () {
            ModelViewer.dispose();
        },
        false
    );

    window.viewer = ModelViewer.create(debug);

    const sceneParams: SceneParams = {
        tableAdVisible: true,
    };

    try {
        // load intro
        window.viewer.addModel(
            Intro.create(window.viewer, introImage, () => {
                introLoad();
                // load assets
                BasicStudioSceneGLTF.loadAssets(window.viewer, lotterySlug, sceneParams);
                loadAssets(window.viewer);

                // window.viewer.run scene and hide intro
                window.viewer.view(() => {
                    BasicStudioSceneGLTF.loadModel(window.viewer, sceneParams);
                    loadModels(window.viewer);
                });
            })
        );
    } catch (e) {
        console.error(e);
    }
}
